import gql from 'graphql-tag';

export const REQUEST_RELATIONSHIPS = gql`
  mutation requestRelationships($input: RequestIntegrationRelationshipsInput!) {
    requestIntegrationRelationships(input: $input) {
      ... on RequestIntegrationRelationshipsSuccess {
        partnerId
        relationships {
          ... on ApprovedIntegrationRelationship {
            id
            hirerAccountId
            hirerOid
            relationship {
              name
              typeCode
            }
          }
          ... on PendingIntegrationRelationship {
            hirerAccountId
            hirerOid
            relationship {
              name
              typeCode
            }
          }
        }
      }
      ... on RequestIntegrationRelationshipsFailure {
        error
      }
    }
  }
`;
